import { handleDownload } from '../../common/utils';

const getFileNameFromUrl = (url) => {
  try {
    // eslint-disable-next-line no-undef
    const pathName = new URL(url)?.pathname;
    return decodeURIComponent(pathName?.split('/')?.pop() || '');
  } catch (error) {
    return '';
  }
};

// eslint-disable-next-line import/prefer-default-export
export const downloadFileFromUrl = async (url, fileName) => {
  if (!url) return;
  try {
    const response = await fetch(url);
    if (!response?.ok) throw new Error('File download failed');
    const blob = await response?.blob();
    // eslint-disable-next-line no-undef
    const objectUrl = window?.URL?.createObjectURL(blob);
    // eslint-disable-next-line no-undef
    const link = document?.createElement('a');
    link.href = objectUrl;
    link.download = fileName || getFileNameFromUrl(url) || 'download';
    // eslint-disable-next-line no-undef
    document?.body?.appendChild(link);
    link?.click();
    link?.remove();
    // eslint-disable-next-line no-undef
    window?.URL?.revokeObjectURL(objectUrl);
  } catch (error) {
    handleDownload(url);
  }
};
